import React, {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from 'react';

/**
 * Lets a locked settings surface, when clicked, ask the TopBar "settings locked"
 * pill to play a brief attention pulse — a subtle explanation of why the surface
 * isn't clickable. The click site (e.g. BenchmarkLockGate) calls `nudge()`; the
 * pill watches `token` and re-pulses each time it changes.
 */
interface SettingsLockNudge {
  token: number;
  nudge: () => void;
}

const SettingsLockNudgeContext = createContext<SettingsLockNudge>({
  token: 0,
  nudge: () => {},
});

export const useSettingsLockNudge = (): SettingsLockNudge =>
  useContext(SettingsLockNudgeContext);

export const SettingsLockNudgeProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [token, setToken] = useState(0);
  const nudge = useCallback(() => setToken(t => t + 1), []);
  const value = useMemo(() => ({ token, nudge }), [token, nudge]);
  return (
    <SettingsLockNudgeContext.Provider value={value}>
      {children}
    </SettingsLockNudgeContext.Provider>
  );
};
